<template>
  <div class="login-component">
    <form @submit.stop.prevent="submit">
      <div class="field">
        <label>email</label>
        <input type="text" name="email" placeholder="Enter email" v-model="email" />
      </div>
      <div class="field">
        <label>password</label>
        <input type="password" name="password" placeholder="Enter password" v-model="password" ref="password" />
      </div>
      <div class="actions">
        <button class="main" ref="submit" type="submit">Login</button>
      </div>
      <transition name="opacity">
        <loader v-if="isLoading" class="loader" label=""/>
      </transition>
      <router-link to="/forgot">I forgot my password</router-link>
    </form>
  </div>
</template>

<script>
  import { validateEmail } from '../../lib/utils'
  import Loader from '../Loader.vue'

  export default {
    name: 'login',
    components: { Loader },
    data() {
      return {
        password: '',
        email: '',
        isLoading: false,
      }
    },
    computed: {
      isLoggedIn() {
        return !!this.$store.state.session.user
      },
    },
    methods: {
      submit() {
        if (!validateEmail(this.email)) {
          this.$toasted.error('Please enter a valid email address')
          return
        }
        if (!this.password || this.password.length < 5 || this.password.length > 10) {
          this.$toasted.error('Password must be between 5 and 10 chars')
          return
        }
        this.isLoading = true
        this.$store.dispatch('SESSION_CREATE', {
          email: this.email.toLowerCase().trim(),
          password: this.password,
        })
        .then((res) => {
          this.isLoading = false
          this.$router.push('/')
        }).catch((err) => {
          this.isLoading = false
          this.$toasted.error(err.body.error || 'Login failed')
        })
      },
    },
  }
</script>

<style scoped lang="scss">
  button {
    margin-right: 20px;
  }
  input {
    margin-bottom: 20px;
  }
  .actions {
    position: relative;
    margin-bottom: 20px;
  }
  .opacity-enter-active, .opacity-leave-active {
    transition: all 0.2s ease;
  }
  .opacity-enter, .opacity-leave-active {
    opacity: 0;
  }
  .loader {
    position: absolute;
    top: 350px;
    left: 50%;
    width: 55px;
    margin-left: -27px;
  }
  .login-component {
    a {
      font-size: 11px;
      font-weight: bold;
      color: $link;
      letter-spacing: 1px;
      margin-bottom: 3px;
    }
  }
  @media (max-width: 500px) {
    .login-component {
      margin: 15px;
      input {
        width: calc(100% - 30px);
      }
    }
  }
  @media (min-width: 501px) {
    .login-component {
      width: 600px;
      margin: 70px auto;
      input {
        width: 600px;
      }
    }
  }
</style>
